export default __webpack_public_path__ + "static/media/slide_3.47651b1f.jpg";